const applicationActions = {
  NAVIGATE_TO: 'NAVIGATE_TO',
  SHOW_ABOUT: 'SHOW_ABOUT',
};

export default applicationActions;
